import { render, staticRenderFns } from "./Observers.vue?vue&type=template&id=b0c9796c&"
import script from "./Observers.vue?vue&type=script&lang=js&"
export * from "./Observers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports